import type { ColorProperty, ColorPropertyInput } from '@src/types';
import { execAdmin } from '../utils';

const gql = String.raw;

interface ColorPropertyGraphQL {
  id: number;
  code: string;
  display: string;
  hexCode?: string | null;
  url?: string | null;
  synonyms: string[];
  family: string[];
  createdAt: string;
  updatedAt: string;
}

interface CreateColorPropertyInput {
  code: string;
  display: string;
  hexCode?: string | null;
  url?: string | null;
  synonyms?: string[];
  family?: string[];
}

interface CreateColorPropertyResponse {
  partner: {
    createColorProperty: ColorPropertyGraphQL;
  };
}

interface CreateColorPropertyVariables {
  partnerCode: string;
  input: CreateColorPropertyInput;
}

const CREATE_COLOR_PROPERTY_MUTATION = gql`
  mutation createColorProperty($partnerCode: String!, $input: ColorPropertyInputTypeAdmin!) {
    partner(code: $partnerCode) {
      createColorProperty(input: $input) {
        id
        code
        display
        hexCode
        url
        synonyms
        family
        createdAt
        updatedAt
      }
    }
  }
`;

export const createColorProperty = async ({
  partnerCode,
  token,
  data,
}: {
  partnerCode: string;
  token: string;
  data: ColorPropertyInput;
}): Promise<ColorProperty> => {
  const input: CreateColorPropertyInput = {
    code: data.code,
    display: data.display,
    hexCode: data.hex_code || null,
    url: data.url || null,
    synonyms: data.synonyms,
    family: data.family,
  };

  const variables: CreateColorPropertyVariables = {
    partnerCode,
    input,
  };

  const response = await execAdmin<CreateColorPropertyVariables, CreateColorPropertyResponse>(
    CREATE_COLOR_PROPERTY_MUTATION,
    { variables }
  );

  const created = response.partner.createColorProperty;

  // Map GraphQL camelCase to frontend snake_case
  return {
    id: created.id,
    partner_code: partnerCode,
    code: created.code,
    display: created.display,
    hex_code: created.hexCode,
    url: created.url,
    synonyms: created.synonyms,
    family: created.family,
    created_at: created.createdAt,
    updated_at: created.updatedAt,
  };
};
